import { eventStarted, eventEnded } from 'utils/eventUtils'
import { trackEvent } from './amplitudeTracking'

const getMeetingStatus = event => {
  if (eventEnded(event)) return 'Post'
  if (eventStarted(event)) return 'In Progress'
  return 'Prepare'
}

const getCheckInSurvey = event => {
  return !!event?.surveyDisplayData?.currentAverage
}

export const trackMeetingBotSet = async (event, location, added = true) => {
  trackEvent(added ? 'Meeting bots added' : 'Meeting bots removed', {
    location,
    meetingId: event.id
  })
}

export const trackMeetingJoined = async (event, location) => {
  trackEvent('Click Join Meeting', {
    location,
    meetingId: event.id,
    noteTakerBot: event.botId ? 'Y' : 'N/A',
    checkInSurvey: getCheckInSurvey(),
    meetingStatus: getMeetingStatus(event)
  })
}

export const track1on1MeetingAttrs = async (
  message,
  event,
  otherAttrs = {}
) => {
  trackEvent(message, {
    meetingId: event.id,
    meetingStatus: getMeetingStatus(event),
    noteTakerBot: event.botId ? 'Y' : 'N/A',
    checkInSurvey: getCheckInSurvey(),
    ...otherAttrs
  })
}
